import React from "react";
import { createComponent } from "@lit/react";
import { BeamSocialShare as _BeamSocialShare } from "./index";

export const BeamSocialShare = createComponent({
  tagName: _BeamSocialShare.tagName,
  elementClass: _BeamSocialShare,
  react: React,
});

export default BeamSocialShare; // default alias for use with async import utils like next/dynamic and react.lazy
